import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { X, Sparkles, ArrowRight, Clock } from "lucide-react";
import api from "@/lib/api";

function Countdown({ to }) {
  const [left, setLeft] = useState("");
  useEffect(() => {
    const tick = () => {
      const diff = new Date(to) - new Date();
      if (diff <= 0) return setLeft("Expired");
      const h = Math.floor(diff / 3.6e6), m = Math.floor((diff % 3.6e6) / 6e4), s = Math.floor((diff % 6e4) / 1000);
      setLeft(`${h}h ${m}m ${s}s`);
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [to]);
  return <span className="font-mono-num">{left}</span>;
}

export function ExclusiveOffersPopup() {
  const [popup, setPopup] = useState(null);
  const [show, setShow] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("omi_popup_seen")) return;
    api.get("/popups/active?page=home").then((r) => {
      if (!r.data) return;
      setPopup(r.data);
      const delay = r.data.trigger === "first_visit" ? 1000 : (r.data.delay_seconds || 6) * 1000;
      setTimeout(() => {
        setShow(true);
        api.post(`/popups/${r.data.id}/event?kind=impression`).catch(() => {});
      }, delay);
    }).catch(() => {});
  }, []);

  const track = (kind) => popup && api.post(`/popups/${popup.id}/event?kind=${kind}`).catch(() => {});
  const close = () => { sessionStorage.setItem("omi_popup_seen", "1"); track("close"); setShow(false); };
  const cta = () => {
    sessionStorage.setItem("omi_popup_seen", "1");
    track("cta");
    setShow(false);
    const url = popup?.cta_url || "/products";
    if (url.startsWith("http")) window.location.href = url; else nav(url);
  };

  if (!show || !popup) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-testid="exclusive-offers-modal">
      <div className="relative w-full max-w-md sm:max-w-lg bg-white rounded-3xl overflow-hidden shadow-2xl animate-fadeUp">
        <button onClick={close} data-testid="popup-close-btn"
          className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 flex items-center justify-center hover:bg-white shadow">
          <X className="w-5 h-5 text-slate-700" />
        </button>
        {popup.desktop_creative ? (
          <img src={popup.desktop_creative} alt={popup.title} className="w-full h-48 object-cover" />
        ) : (
          <div className="bg-brand-gradient p-8 text-white">
            <div className="inline-flex items-center gap-2 bg-white/15 px-3 py-1 rounded-full text-xs font-bold mb-4">
              <Sparkles className="w-3.5 h-3.5" /> EXCLUSIVE · LIMITED TIME
            </div>
            <h3 className="font-display text-3xl font-extrabold leading-tight">{popup.title}</h3>
            {popup.benefit && <p className="mt-2 text-teal-300 font-mono-num font-bold text-lg">{popup.benefit}</p>}
          </div>
        )}
        <div className="p-6">
          {popup.desktop_creative && <h3 className="font-display text-2xl font-extrabold text-[#0B223D] mb-1">{popup.title}</h3>}
          <p className="text-slate-500">{popup.description}</p>
          {popup.countdown_to && (
            <div className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-600 bg-amber-50 px-3 py-1.5 rounded-full">
              <Clock className="w-4 h-4" /> Ends in <Countdown to={popup.countdown_to} />
            </div>
          )}
          <button onClick={cta} data-testid="popup-cta-btn"
            className="w-full mt-4 bg-[#0B223D] hover:bg-[#06182B] text-white font-bold py-3.5 rounded-xl flex items-center justify-center gap-2 transition-colors">
            {popup.cta_text || "Claim This Offer"} <ArrowRight className="w-4 h-4" />
          </button>
          <button onClick={close} className="w-full mt-2 text-sm text-slate-400 font-medium py-2">No thanks</button>
        </div>
      </div>
    </div>
  );
}
